// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const loadingSpinner: Styleguide["loadingSpinner"] = {};

export default loadingSpinner;
